import { Components, Theme } from "@mui/material/styles"

export const muiButton = (): Components<
  Omit<Theme, "components">
>["MuiButton"] => {
  return {
    styleOverrides: {
      root: {
        borderRadius: "8px",
        padding: "8px 12px",
      },
    },
  }
}
